import type { FloatLabelDesignTokens } from '@primeuix/themes/types/floatlabel'

import { bothSchemes } from '../utils'

/**
 * Вариант `on` — лейбл сидит на верхней границе поля.
 * Замеры компонента «Поле для ввода» из макета:
 *
 * | Состояние | Лейбл | Позиция |
 * |---|---|---|
 * | пусто | 16 Medium #ABADB0 | по центру поля, текст на 13px |
 * | фокус / заполнено | 12 Medium #ABADB0 | плашка 22px r20 на границе, x=7 |
 *
 * Плашка белая (перекрывает бордер), её паддинг 6px — поэтому текст лейбла
 * в обоих состояниях стоит на тех же 13px, что и значение поля.
 */
export const floatLabelConfig = (): FloatLabelDesignTokens => ({
  root: {
    /* плашка стоит на 7px, её паддинг 6px — текст лейбла попадает на 13px */
    positionX: 'calc(var(--field-padding-x) - var(--space-3))',
    positionY: 'var(--space-6)',
    fontWeight: 'var(--fw-medium)',
    transitionDuration: '.15s',
    active: { fontSize: '12px', fontWeight: 'var(--fw-medium)' },
  },
  on: {
    borderRadius: 'var(--radius-xl)',
    /* 12px текста + 2×5px = плашка 22px из макета */
    active: { padding: '5px var(--space-3)' },
  },
  colorScheme: bothSchemes({
    root: {
      color: 'var(--text-color-secondary)',
      focusColor: 'var(--text-color-secondary)',
      activeColor: 'var(--text-color-secondary)',
      invalidColor: 'var(--primary-500)',
    },
    on: {
      active: { background: 'var(--surface-card)' },
    },
  }),
})
